import { visualRoutes } from "@/Router/routes";
import useLocalization from "@/hooks/useLocalization";
import useUser from "@/hooks/useUser";
import icons from "@/tools/icons";
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { DrawerProps } from "./DrawerButton";

export default function NavigationDrawer({ open, handleClose }: DrawerProps) {
  const navigate = useNavigate();
  const { isMtUser, logout } = useUser();

  const currentPath = useLocation().pathname;

  const { t } = useLocalization();

  return (
    <Drawer open={open} onClose={handleClose} anchor="top">
      <Toolbar />
      <List>
        {visualRoutes.filter((route) => !route.requiresMtUser || isMtUser).map(({ path, visual: { id, icon } }) => (
          <ListItem key={id} disablePadding>
            <ListItemButton
              disabled={currentPath === path}
              onClick={() => {
                navigate(path);
                handleClose();
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={t(`page:${id}`)} />
            </ListItemButton>
          </ListItem>
        ))}
        <Divider sx={{ marginTop: "12px" }} />
        <ListItem onClick={logout}>
          <ListItemIcon>
            <icons.Logout />
          </ListItemIcon>
          <ListItemText primary={t("command:logOut")} />
        </ListItem>
      </List>
    </Drawer>
  );
}
